import React from 'react';
import NotificationsPageContent from '../../Notifications/Components/NotificationsPageContent';

export default function NotificationsPage() {
    return <NotificationsPageContent />;
}
